import type { ReactNode } from 'react'

export interface FieldProps {
  label: string
  hint?: ReactNode
  /** Id of the control, so the visible label names it. */
  htmlFor?: string
  /** Id for the label text (for controls named with aria-labelledby, such as Select). */
  labelId?: string
  children: ReactNode
}

/** One labelled row of a settings form: label and hint on the left, the control on the right. */
export function Field({ label, hint, htmlFor, labelId, children }: FieldProps) {
  return (
    <div className="set-field">
      <div className="sf-label">
        <b id={labelId}>{htmlFor ? <label htmlFor={htmlFor}>{label}</label> : label}</b>
        {hint && <span className="hint">{hint}</span>}
      </div>
      <div className="sf-control">{children}</div>
    </div>
  )
}
